<template>
  <vs-table hover-flat v-if="faxes && faxes.length" :data="faxes">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('fax_sent_at')"></vs-th>
      <vs-th v-text="$t('fax_to_number')"></vs-th>
      <vs-th v-text="$t('fax_customer_name')"></vs-th>
      <vs-th v-text="$t('fax_file_name')"></vs-th>
      <vs-th v-text="$t('fax_pages')"></vs-th>
      <vs-th v-text="$t('status')"></vs-th>
      <vs-th class="text-center" v-text="$t('function')"></vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.count"></vs-td>
        <vs-td v-text="tr.created_at"></vs-td>
        <vs-td v-text="tr.to_number"></vs-td>
        <vs-td v-text="tr.customer_name"></vs-td>
        <vs-td v-text="tr.orig_filename"></vs-td>
        <vs-td v-text="tr.pages"></vs-td>
        <vs-td>
          <vs-chip :color="statusColor(tr.status)" v-text="$t(`fax_status_${tr.status}`)"></vs-chip>
          <!--
            성공한 건에도 error_reason 이 남는다. dialplan 의 s / h 확장이 결과 스크립트를
            두 번 부르는데, 뒤늦게 도착한 h 쪽이 HANGUP 을 채워 넣기 때문이다.
            실패한 건에만 사유를 보여준다.
          -->
          <div
            class="text-danger text-sm mt-1"
            v-if="tr.error_reason && (tr.status === 'failed' || tr.status === 'cancelled')"
            v-text="tr.error_reason"
          ></div>
        </vs-td>
        <vs-td>
          <div class="flex justify-center">
            <vs-button
              v-if="tr.has_file"
              color="primary"
              type="border"
              icon-pack="feather"
              icon="icon-file-text"
              size="small"
              @click.prevent="$emit('openFile', tr.uuid)"
            >{{ $t('fax_open_pdf') }}</vs-button>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
export default {
  name: 'Shared.Fax.OutboundList',
  props: {
    faxes: {
      type: [Object, Array],
      required: true
    }
  },
  methods: {
    statusColor (status) {
      switch (status) {
      case 'success':
        return 'success'
      case 'failed':
      case 'cancelled':
        return 'danger'
      default:
        // queued / sending
        return 'warning'
      }
    }
  }
}
</script>

<style scoped>

</style>
